<div class="m-2">
    <kendo-label *ngIf="isLabelVisible()" [for]="getControlName()" [text]="getLabel()">
        <span *ngIf="isRequired()" class="required">*</span>
    </kendo-label>
    <kendo-datepicker *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="internalValue" [required]="isRequired()"
        [format]="getPattern()" (ngModelChange)="onValueChange()" [max]="getMaxValue()">
    </kendo-datepicker>
</div>